// Values for the `X-Tmc-Client` header, telling the backend which auth cookie
// to use when a patient and a staff session coexist in the same browser. Must
// match the keys of `COOKIE_BY_CLIENT_HINT` in backend/tmc_auth/authentication.py.
export const TMC_CLIENT_PATIENT = 'patient'
export const TMC_CLIENT_EMPLOYEE = 'employee'

export type TmcClientHint = typeof TMC_CLIENT_PATIENT | typeof TMC_CLIENT_EMPLOYEE
